import React from 'react';
import { Link } from 'react-router-dom';

// import ContactIcons from '../Contact/ContactIcons';

// const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        {/* <img src={`${PUBLIC_URL}/images/me.png`} alt="" /> */}
      </Link>
      <header>
        <h2>Sako Tech LLC</h2>
        <p>
          <a href="mailto:info@sakotechllc.com">info@sakotechllc.com</a>
        </p>
        <p>Seattle, WA</p>
      </header>
    </section>
    <section className="blurb">
      <h2>About</h2>
      <p>
        At Sako Tech, we specialize in delivering stunning,
        user-centered web design and development services.
        With expertise across a wide range of platforms—including
        WordPress, Webflow, HubSpot, Squarespace, Wix, and more—we
        provide scalable and custom-tailored solutions to elevate your online presence.
        Our team of talented designers and developers ensures your website
        not only looks amazing but performs seamlessly. From responsive designs
        to intuitive user experiences, we&apos;re committed to crafting websites that
        drive engagement and achieve your business goals.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/services') ? (
            <Link to="/services" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Us
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      {/* <ContactIcons /> */}
      <p className="copyright">
        &copy; 2026 SAKO TECH LLC.
      </p>
    </section>
  </section>
);

export default SideBar;
